<!-- 用于直接显示在界面的刻度尺 -->
<template>
  <div class="cs-content" ref="content">
    <div class="cs-rule" ref="rulepage">
      <!--刻度表-->
      <div class="cs-scrollrule" ref="scrollrule">
        <ul class="cs-scrollrule-hook" ref="rulehook">
          <!--正常刻度表-->
          <li
            class="cs-scroll-item"
            v-for="(item, index) in rulerList"
            :key="index"
            :style="{ width: gridWidth + 'px' }"
          >
            <div
              class="cs-scroll-item-rule"
              :class="{ 'cs-scroll-item-rule-long': item.long }"
            >
              <div
                class="cs-scroll-item-rule-line"
                :style="{ background: lineColor }"
              ></div>
            </div>
            <div class="cs-scroll-item-num" v-if="item.long">{{
              item.text
            }}</div>
          </li>
        </ul>
      </div>
      <!--刻度表的针-->
      <div class="cs-scroll-item-pointer">
        <div
          class="cs-circle"
          :style="{ borderTop: '10px solid ' + theme }"
        ></div>
        <!--  <div class="cs-line"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from 'better-scroll'
import { debounce } from '@/common/common.js'
export default {
  name: 'cs-ruler',
  props: {
    /* 主题色 */
    theme: {
      type: String,
      default: '#6236ff'
    },
    lineColor: {
      type: String,
      default: '#d0d2d9'
    },
    // 初始值
    NowNum: {
      type: Number,
      default: 0
    },
    // 最大刻度
    maxNum: {
      type: Number,
      default: 300
    },
    // 最小刻度
    minNum: {
      type: Number,
      default: 0
    },
    // 刻度尺每格的宽度
    gridWidth: {
      type: Number,
      default: 14
    },
    // 字体大小
    numSize: {
      type: Number,
      default: 32
    },
    // 每个格子多大
    oneGridValue: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      rulerList: [],
      leftNum: 0,
      contentWidth: 0,
      curNum: 0
    }
  },
  watch: {
    rulerOptions() {
      this.init()
      this.$nextTick(() => {
        this.scrollrule.refresh()
      })
    }
  },
  computed: {
    halfContentWidth() {
      return Math.round(this.contentWidth / 2)
    },
    rulerOptions() {
      return {
        minNum: this.minNum,
        maxNum: this.maxNum,
        NowNum: this.NowNum,
        gridWidth: this.gridWidth,
        oneGridValue: this.oneGridValue
      }
    }
  },
  created() {
    this.debounceIsScrollEnd = debounce(this.computedIsScrollEnd, 200)
  },
  mounted() {
    this.init()
    this.$nextTick(() => {
      this.initScroll()
      this.initPositin()
    })
  },
  methods: {
    initRuler() {
      this.init()
      this.$nextTick(() => {
        this.scrollrule.refresh()
      })
    },
    //初始化位置
    initPositin() {
      let offset = Math.round(
        ((this.NowNum - this.minNum) / this.oneGridValue + this.leftNum) *
          this.gridWidth -
          this.halfContentWidth
      )

      //this.scrollrule.scrollTo( -offset, 0, 0)
      let el = this.$refs.scrollrule
      el.scrollLeft = offset
      /* this.$nextTick(()=>{
          this.scrollrule.scrollBy(-(newOffSetX - oldOffSetX), 0, 0)
      }); */
    },
    init() {
      let arr = []
      /* 设置最小值前面的刻度尺 */
      this.contentWidth = this.$refs.content.clientWidth
      this.leftNum = Math.ceil(this.contentWidth / this.gridWidth)
      for (let i = 0; i < this.leftNum; i++) {
        arr.push({
          text: '',
          long: false
        })
      }
      /* 范围内的刻度尺 需要+1格 */
      let centerNum =
        Math.ceil((this.maxNum - this.minNum) / this.oneGridValue) + 1
      for (let i = 0; i < centerNum; i++) {
        let obj = {
          text: '',
          long: false
        }
        let cur = this.minNum + i * this.oneGridValue
        obj.text = cur
        //如果当前数值是每格的10倍
        if (cur % (this.oneGridValue * 10) == 0) {
          obj.long = true
        }
        arr.push(obj)
      }
      /* 设置最大值前面的刻度尺 */
      for (let i = 0; i < this.leftNum; i++) {
        arr.push({
          text: ''
        })
      }
      this.rulerList = arr
    },
    computedIsScrollEnd() {
      if (!this.isTouch) {
        let el = this.$refs.scrollrule
        let pos = {
          x: -el.scrollLeft,
          y: 0
        }
        this.scrollX = Math.abs(Math.round(pos.x))
        //滑动后的小距离
        let littleNum =
          (this.scrollX -
            this.gridWidth * this.leftNum +
            this.halfContentWidth) %
          this.gridWidth
        //计算距离下一个刻度的差值
        let vul = this.gridWidth - littleNum
        if (this.curNum < this.maxNum && this.curNum > this.minNum) {
          // 加入差值比较大,再进行吸附,大于一半的距离,就往右边吸附差值的距离,小于一半的距离,就往左边吸附滑动的距离
          if (vul > 0) {
            if (littleNum > this.gridWidth / 2) {
              // this.scrollrule.scrollBy(-vul, 0, 0)
              el.scrollLeft = el.scrollLeft + vul
            } else {
              //this.scrollrule.scrollBy(littleNum, 0, 0)
              el.scrollLeft = el.scrollLeft - littleNum
            }
          }
        } else if (this.curNum >= this.maxNum) {
          let offset =
            ((this.maxNum - this.minNum) * (1 / this.oneGridValue) +
              this.leftNum) *
              this.gridWidth -
            this.halfContentWidth
          //this.scrollrule.scrollTo( -offset,0, 0 )
          el.scrollLeft = offset
        } else {
          let offset = this.leftNum * this.gridWidth - this.halfContentWidth
          //this.scrollrule.scrollTo( -offset, 0, 0)
          el.scrollLeft = offset
        }
      }
    },
    // 初始化滚动
    initScroll() {
      let el = this.$refs.scrollrule
      el.addEventListener('touchstart', () => {
        this.isTouch = true
      })
      el.addEventListener('touchend', () => {
        this.isTouch = false
        this.debounceIsScrollEnd()
      })
      el.addEventListener('touchcancel', () => {
        this.isTouch = false
      })
      el.addEventListener('scroll', (e) => {
        let pos = {
          x: -e.target.scrollLeft,
          y: 0
        }
        if (pos.x > 0) {
          return
        }
        this.scrollX = Math.abs(Math.round(pos.x))
        //当前的值
        this.curNum =
          Math.round(
            (this.scrollX -
              this.gridWidth * this.leftNum +
              this.halfContentWidth) /
              this.gridWidth
          ) *
            this.oneGridValue +
          this.minNum
        this.curNum = parseInt(this.curNum * 10) / 10
        this.curNum = this.filterCurNum(this.curNum)
        this.$emit('change', this.curNum)
        this.debounceIsScrollEnd()
      })
      return
      this.scrollrule = new BScroll(this.$refs.scrollrule, {
        // 实时监听滚动的位置并返回
        probeType: 3,
        scrollX: true,
        bounce: false
      })

      // 监听滚动开始
      this.scrollrule.on('scrollStart', (pos) => {
        this.$emit('scroll-start', true)
      })

      // 监听滚动
      this.scrollrule.on('scroll', (pos) => {
        if (pos.x > 0) {
          return
        }
        this.scrollX = Math.abs(Math.round(pos.x))
        //当前的值
        this.curNum =
          Math.round(
            (this.scrollX -
              this.gridWidth * this.leftNum +
              this.halfContentWidth) /
              this.gridWidth
          ) *
            this.oneGridValue +
          this.minNum
        this.curNum = parseInt(this.curNum * 10) / 10
        this.curNum = this.filterCurNum(this.curNum)
        this.$emit('change', this.curNum)
      })

      //滚动结束监听
      this.scrollrule.on('scrollEnd', (pos) => {
        console.log(pos)
        this.scrollX = Math.abs(Math.round(pos.x))
        //滑动后的小距离
        let littleNum =
          (this.scrollX -
            this.gridWidth * this.leftNum +
            this.halfContentWidth) %
          this.gridWidth
        //计算距离下一个刻度的差值
        let vul = this.gridWidth - littleNum
        if (this.curNum < this.maxNum && this.curNum > this.minNum) {
          // 加入差值比较大,再进行吸附,大于一半的距离,就往右边吸附差值的距离,小于一半的距离,就往左边吸附滑动的距离
          if (vul > 0) {
            if (littleNum > this.gridWidth / 2) {
              this.scrollrule.scrollBy(-vul, 0, 0)
            } else {
              this.scrollrule.scrollBy(littleNum, 0, 0)
            }
          }
        } else if (this.curNum >= this.maxNum) {
          let offset =
            ((this.maxNum - this.minNum) * (1 / this.oneGridValue) +
              this.leftNum) *
              this.gridWidth -
            this.halfContentWidth
          this.scrollrule.scrollTo(-offset, 0, 0)
        } else {
          let offset = this.leftNum * this.gridWidth - this.halfContentWidth
          this.scrollrule.scrollTo(-offset, 0, 0)
        }
      })
      this.scrollrule.on('refresh', () => {
        this.initPositin()
      })
    },
    filterCurNum(number) {
      if (number < this.minNum) {
        number = this.minNum
      } else if (number > this.maxNum) {
        number = this.maxNum
      }
      return number
    }
  }
}
</script>
<style scoped lang="scss">
.cs-content {
  width: 100%;
}

.cs-rule {
  position: relative;
  width: 100%;
  overflow: hidden;
  --pointer-color: rgb(97, 206, 81);
  --rule-width: 40;
  --num-size: 50;
}

.cs-scroll-item {
  display: inline-block;
  text-align: center;
  vertical-align: top;
}

/*刻度表数字*/
.cs-scroll-item-num {
  width: 50px;
  margin-left: -25px;
  margin-top: 8px;
  text-align: center;
  font-size: var(--num-size + 'px');
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(59, 71, 97, 0.5);
}

/*中间红色指针*/
.cs-scroll-item-pointer {
  position: absolute;
  top: 0;
  left: 50%;
  height: 35px;
  transform: translate(-50%, 0);
  display: flex;
  align-items: center;
  flex-direction: column;

  .cs-circle {
    width: 0px;
    height: 0px;
    border-top: 10px solid #6236ff;
    border-bottom: 0px solid transparent;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
  }

  .cs-line {
    margin-top: 2px;
    width: 3px;
    height: 25px;
    background: #6236ff;
  }
}

.cs-scrollrule {
  overflow-x: scroll;
}

.cs-scrollrule-hook {
  list-style: none;
  overflow: hidden;
  border-collapse: collapse;
  white-space: nowrap;
  display: inline-block;
}

.cs-scroll-item-rule {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 20px;
  box-sizing: border-box;
}

.cs-scroll-item-rule-long {
  height: 36px;
}

.cs-scroll-item-rule-line {
  position: absolute;
  left: -1px;
  top: 0;
  bottom: 0;
  width: 1px;
  bottom: 0;
}
</style>
